exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-divider[data-v-b1e120c6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;position:relative}.el-divider .item[data-v-b1e120c6]{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background:#fff}.el-divider .left[data-v-b1e120c6]{right:0;padding-right:10px}.el-divider .right[data-v-b1e120c6]{right:0;padding-left:10px}", ""]);

// exports
